import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

// components
import { RightArrow } from "components/common";
import { Avatar } from "components/common";

const UserProfile = () => {
  const { userInfo } = useSelector((state) => state.user);
  const navigate = useNavigate();

  return (
    <Wrapper onClick={() => navigate("/all/account")}>
      <UserInfo>
        <Avatar src={userInfo.imageUrl} size={60} />

        <div data-clarity-mask="True">
          <p className="name">{userInfo?.name}</p>
          <p className="mobile">{userInfo?.phoneNumber}</p>
        </div>
      </UserInfo>

      <RightArrow />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 16px 0;
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  img {
    margin-right: 12px;
  }

  p.name {
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    color: ${(props) => props.theme.primaryTextColor};
  }
  p.mobile {
    font-size: 14px;
    line-height: 18px;
    color: #9a9ea8;
    opacity: 0.8;
  }
`;

export default UserProfile;
